"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var constants_1 = require("./constants");

function jsonReplacer(key, value) {
  var data = this[key];

  if (data instanceof Date) {
    value = {
      type: constants_1.JsonTypes.Date,
      data: data.getTime()
    };
  } else if (Buffer.isBuffer(data)) {
    value = {
      type: constants_1.JsonTypes.Buffer,
      data: data.toString('hex')
    };
  } else if (bn_js_1.default.isBN(data)) {
    value = {
      type: constants_1.JsonTypes.BN,
      data: data.toString(16)
    };
  }

  return value;
}

exports.jsonReplacer = jsonReplacer;

function jsonReviver(key, value) {
  if (value && typeof value === 'object' && value.type) {
    switch (value.type) {
      case constants_1.JsonTypes.Buffer:
        value = Buffer.from(value.data, 'hex');
        break;

      case constants_1.JsonTypes.BN:
        value = new bn_js_1.default(value.data, 16);
        break;

      case constants_1.JsonTypes.Date:
        value = new Date(value.data);
        break;
    }
  }

  return value;
}

exports.jsonReviver = jsonReviver;